import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const types ={
  SET_AUTHENTICATED:'SET_AUTHENTICATED',
  SET_USER:"SET_USER"
}

const state ={
  isAuthenticated:false,
  user:{},
  mapstyle: [
    {
      "featureType": "land",
      "elementType": "geometry",
      "stylers": {
        "color": "#0c2f55ff",
        "visibility": "on"
      }
    }, {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#0c2f55ff",
        "visibility": "on"
      }
    }, {
      "featureType": "building",
      "elementType": "geometry.fill",
      "stylers": {
        "color": "#012346ff",
        "visibility": "on"
      }
    }, {
      "featureType": "building",
      "elementType": "geometry.stroke",
      "stylers": {
        "color": "#00112dff",
        "visibility": "on"
      }
    }, {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": {
        "color": "#0c2f55ff",
        "visibility": "on"
      }
    }, {
      "featureType": "village",
      "elementType": "labels",
      "stylers": {
        "visibility": "on"
      }
    }, {
      "featureType": "town",
      "elementType": "labels",
      "stylers": {
        "visibility": "on"
      }
    }, {
      "featureType": "district",
      "elementType": "labels",
      "stylers": {
        "visibility": "on"
      }
    }, {
      "featureType": "country",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#00f0ffff",
        "visibility": "on"
      }
    }, {
      "featureType": "city",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#00f0ffff",
        "visibility": "on"
      }
    }, {
      "featureType": "continent",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#00f0ffff",
        "visibility": "on"
      }
    }, {
      "featureType": "poilabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "on"
      }
    }, {
      "featureType": "poilabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "scenicspotslabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "scenicspotslabel",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#0c2f55ff",
        "visibility": "on"
      }
    }, {
      "featureType": "transportationlabel",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#0c2f55ff",
        "visibility": "on"
      }
    }, {
      "featureType": "transportationlabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "airportlabel",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#0c2f55ff",
        "visibility": "on"
      }
    }, {
      "featureType": "airportlabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "road",
      "elementType": "geometry.fill",
      "stylers": {
        "color": "#046077ff",
        "visibility": "on"
      }
    }, {
      "featureType": "road",
      "elementType": "geometry.stroke",
      "stylers": {
        "color": "#003d4fff",
        "visibility": "on"
      }
    }, {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": {
        "weight": 8
      }
    }, {
      "featureType": "green",
      "elementType": "geometry",
      "stylers": {
        "color": "#043b6aff",
        "visibility": "on"
      }
    }, {
      "featureType": "scenicspots",
      "elementType": "geometry",
      "stylers": {
        "color": "#0c2f55ff",
        "visibility": "on"
      }
    }, {
      "featureType": "scenicspots",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#0c2f55ff",
        "visibility": "on"
      }
    }, {
      "featureType": "scenicspots",
      "elementType": "labels.text.stroke",
      "stylers": {
        "weight": 1,
        "color": "#95bee5ff",
        "visibility": "off"
      }
    }, {
      "featureType": "continent",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#95bee5ff",
        "visibility": "off",
        "weight": 1
      }
    }, {
      "featureType": "country",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#95bee5ff",
        "visibility": "off",
        "weight": 1
      }
    }, {
      "featureType": "city",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#95bee5ff",
        "visibility": "off",
        "weight": 1
      }
    }, {
      "featureType": "city",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "scenicspotslabel",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#95bee5ff",
        "visibility": "off",
        "weight": 1
      }
    }, {
      "featureType": "airportlabel",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#95bee5ff",
        "visibility": "off",
        "weight": 1
      }
    }, {
      "featureType": "transportationlabel",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#95bee5ff",
        "visibility": "off",
        "weight": 1
      }
    }, {
      "featureType": "railway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "subway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "highwaysign",
      "elementType": "labels",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "nationalwaysign",
      "elementType": "labels",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "nationalwaysign",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "provincialwaysign",
      "elementType": "labels",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "provincialwaysign",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "tertiarywaysign",
      "elementType": "labels",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "tertiarywaysign",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "subwaylabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "subwaylabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#50e3c2ff",
        "visibility": "on",
        "weight": 90
      }
    }, {
      "featureType": "road",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#95bee500",
        "visibility": "off",
        "weight": 1
      }
    }, {
      "featureType": "shopping",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "scenicspots",
      "elementType": "labels",
      "stylers": {
        "visibility": "on"
      }
    }, {
      "featureType": "scenicspotslabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "on"
      }
    }, {
      "featureType": "manmade",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "manmade",
      "elementType": "labels",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "highwaysign",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "water",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#043b6a00",
        "visibility": "on"
      }
    }, {
      "featureType": "road",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "6"
      }
    }, {
      "featureType": "road",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "7"
      }
    }, {
      "featureType": "road",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "8"
      }
    }, {
      "featureType": "road",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "9"
      }
    }, {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "6"
      }
    }, {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "7"
      }
    }, {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "8"
      }
    }, {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "9"
      }
    }, {
      "featureType": "road",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "6"
      }
    }, {
      "featureType": "road",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "7"
      }
    }, {
      "featureType": "road",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "8"
      }
    }, {
      "featureType": "road",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "9"
      }
    }, {
      "featureType": "road",
      "elementType": "labels.text",
      "stylers": {
        "fontsize": 24
      }
    }, {
      "featureType": "highway",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#95bee500",
        "visibility": "off",
        "weight": 1
      }
    }, {
      "featureType": "highway",
      "elementType": "geometry.fill",
      "stylers": {
        "color": "#046077ff",
        "visibility": "on"
      }
    }, {
      "featureType": "highway",
      "elementType": "geometry.stroke",
      "stylers": {
        "color": "#1c4f7eff"
      }
    }, {
      "featureType": "highway",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#50e3c2ff",
        "visibility": "on"
      }
    }, {
      "featureType": "highway",
      "elementType": "geometry",
      "stylers": {
        "weight": 3
      }
    }, {
      "featureType": "nationalway",
      "elementType": "geometry.fill",
      "stylers": {
        "color": "#046077ff",
        "visibility": "on"
      }
    }, {
      "featureType": "nationalway",
      "elementType": "geometry.stroke",
      "stylers": {
        "color": "#1c4f7eff"
      }
    }, {
      "featureType": "nationalway",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#50e3c2ff",
        "visibility": "on"
      }
    }, {
      "featureType": "nationalway",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#50e3c200",
        "visibility": "off",
        "weight": 1
      }
    }, {
      "featureType": "nationalway",
      "elementType": "geometry",
      "stylers": {
        "weight": 3
      }
    }, {
      "featureType": "provincialway",
      "elementType": "geometry.fill",
      "stylers": {
        "color": "#046077ff",
        "visibility": "on"
      }
    }, {
      "featureType": "cityhighway",
      "elementType": "geometry.fill",
      "stylers": {
        "color": "#046077ff",
        "visibility": "on"
      }
    }, {
      "featureType": "arterial",
      "elementType": "geometry.fill",
      "stylers": {
        "color": "#046077ff",
        "visibility": "on"
      }
    }, {
      "featureType": "tertiaryway",
      "elementType": "geometry.fill",
      "stylers": {
        "color": "#046077ff",
        "visibility": "on"
      }
    }, {
      "featureType": "fourlevelway",
      "elementType": "geometry.fill",
      "stylers": {
        "color": "#046077ff",
        "visibility": "on"
      }
    }, {
      "featureType": "local",
      "elementType": "geometry.fill",
      "stylers": {
        "color": "#046077ff",
        "visibility": "on"
      }
    }, {
      "featureType": "provincialway",
      "elementType": "geometry.stroke",
      "stylers": {
        "color": "#003d4fff",
        "visibility": "on"
      }
    }, {
      "featureType": "cityhighway",
      "elementType": "geometry.stroke",
      "stylers": {
        "color": "#003d4fff",
        "visibility": "on"
      }
    }, {
      "featureType": "arterial",
      "elementType": "geometry.stroke",
      "stylers": {
        "color": "#003d4fff",
        "visibility": "on"
      }
    }, {
      "featureType": "tertiaryway",
      "elementType": "geometry.stroke",
      "stylers": {
        "color": "#003d4fff",
        "visibility": "on"
      }
    }, {
      "featureType": "fourlevelway",
      "elementType": "geometry.stroke",
      "stylers": {
        "color": "#003d4fff",
        "visibility": "on"
      }
    }, {
      "featureType": "local",
      "elementType": "geometry.stroke",
      "stylers": {
        "color": "#003d4fff",
        "visibility": "on"
      }
    }, {
      "featureType": "local",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#50e3c2ff",
        "visibility": "on"
      }
    }, {
      "featureType": "local",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#95bee500",
        "visibility": "off",
        "weight": 1
      }
    }, {
      "featureType": "fourlevelway",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#50e3c2ff",
        "visibility": "on"
      }
    }, {
      "featureType": "tertiaryway",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#50e3c2ff",
        "visibility": "on"
      }
    }, {
      "featureType": "arterial",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#50e3c2ff",
        "visibility": "on"
      }
    }, {
      "featureType": "cityhighway",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#50e3c2ff",
        "visibility": "on"
      }
    }, {
      "featureType": "provincialway",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#50e3c2ff",
        "visibility": "on"
      }
    }, {
      "featureType": "provincialway",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#95bee500",
        "visibility": "off",
        "weight": 1
      }
    }, {
      "featureType": "cityhighway",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#95bee500",
        "visibility": "off",
        "weight": 1
      }
    }, {
      "featureType": "arterial",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#95bee5ff",
        "visibility": "off",
        "weight": 1
      }
    }, {
      "featureType": "tertiaryway",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#95bee500",
        "visibility": "off",
        "weight": 1
      }
    }, {
      "featureType": "fourlevelway",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#95bee500",
        "visibility": "off",
        "weight": 1
      }
    }, {
      "featureType": "fourlevelway",
      "elementType": "geometry",
      "stylers": {
        "weight": 1
      }
    }, {
      "featureType": "tertiaryway",
      "elementType": "geometry",
      "stylers": {
        "weight": 1
      }
    }, {
      "featureType": "local",
      "elementType": "geometry",
      "stylers": {
        "weight": 1
      }
    }, {
      "featureType": "provincialway",
      "elementType": "geometry",
      "stylers": {
        "weight": 3
      }
    }, {
      "featureType": "cityhighway",
      "elementType": "geometry",
      "stylers": {
        "weight": 3
      }
    }, {
      "featureType": "arterial",
      "elementType": "geometry",
      "stylers": {
        "weight": 3
      }
    }, {
      "featureType": "highway",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "6"
      }
    }, {
      "featureType": "highway",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "7"
      }
    }, {
      "featureType": "highway",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "8"
      }
    }, {
      "featureType": "highway",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "9"
      }
    }, {
      "featureType": "highway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "6"
      }
    }, {
      "featureType": "highway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "7"
      }
    }, {
      "featureType": "highway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "8"
      }
    }, {
      "featureType": "highway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "9"
      }
    }, {
      "featureType": "highway",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "6"
      }
    }, {
      "featureType": "highway",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "7"
      }
    }, {
      "featureType": "highway",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "8"
      }
    }, {
      "featureType": "highway",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "9"
      }
    }, {
      "featureType": "nationalway",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "6"
      }
    }, {
      "featureType": "nationalway",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "7"
      }
    }, {
      "featureType": "nationalway",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "8"
      }
    }, {
      "featureType": "nationalway",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "9"
      }
    }, {
      "featureType": "nationalway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "6"
      }
    }, {
      "featureType": "nationalway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "7"
      }
    }, {
      "featureType": "nationalway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "8"
      }
    }, {
      "featureType": "nationalway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "9"
      }
    }, {
      "featureType": "nationalway",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "6"
      }
    }, {
      "featureType": "nationalway",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "7"
      }
    }, {
      "featureType": "nationalway",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "8"
      }
    }, {
      "featureType": "nationalway",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "9"
      }
    }, {
      "featureType": "provincialway",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "8,10",
        "level": "8"
      }
    }, {
      "featureType": "provincialway",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "8,10",
        "level": "9"
      }
    }, {
      "featureType": "provincialway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "8,10",
        "level": "8"
      }
    }, {
      "featureType": "provincialway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "8,10",
        "level": "9"
      }
    }, {
      "featureType": "provincialway",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "8,10",
        "level": "8"
      }
    }, {
      "featureType": "provincialway",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "8,10",
        "level": "9"
      }
    }, {
      "featureType": "cityhighway",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "6"
      }
    }, {
      "featureType": "cityhighway",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "7"
      }
    }, {
      "featureType": "cityhighway",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "8"
      }
    }, {
      "featureType": "cityhighway",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "9"
      }
    }, {
      "featureType": "cityhighway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "6"
      }
    }, {
      "featureType": "cityhighway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "7"
      }
    }, {
      "featureType": "cityhighway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "8"
      }
    }, {
      "featureType": "cityhighway",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "9"
      }
    }, {
      "featureType": "cityhighway",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "6"
      }
    }, {
      "featureType": "cityhighway",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "7"
      }
    }, {
      "featureType": "cityhighway",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "8"
      }
    }, {
      "featureType": "cityhighway",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "6,9",
        "level": "9"
      }
    }, {
      "featureType": "arterial",
      "stylers": {
        "curZoomRegionId": "0",
        "curZoomRegion": "9,9",
        "level": "9"
      }
    }, {
      "featureType": "arterial",
      "elementType": "geometry",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "9,9",
        "level": "9"
      }
    }, {
      "featureType": "arterial",
      "elementType": "labels",
      "stylers": {
        "visibility": "off",
        "curZoomRegionId": "0",
        "curZoomRegion": "9,9",
        "level": "9"
      }
    }, {
      "featureType": "districtlabel",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#95bee5ff"
      }
    }, {
      "featureType": "estatelabel",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#95bee5ff"
      }
    }, {
      "featureType": "estatelabel",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#ffffff0"
      }
    }, {
      "featureType": "estatelabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "businesstowerlabel",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#95bee5ff"
      }
    }, {
      "featureType": "businesstowerlabel",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#ffffff00"
      }
    }, {
      "featureType": "businesstowerlabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "companylabel",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#ffffff0"
      }
    }, {
      "featureType": "companylabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "companylabel",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#95bee5ff"
      }
    }, {
      "featureType": "governmentlabel",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#95bee5ff"
      }
    }, {
      "featureType": "governmentlabel",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#ffffff0"
      }
    }, {
      "featureType": "governmentlabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "restaurantlabel",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#95bee5ff"
      }
    }, {
      "featureType": "restaurantlabel",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#ffffff0"
      }
    }, {
      "featureType": "restaurantlabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "restaurantlabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "businesstowerlabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "on"
      }
    }, {
      "featureType": "estatelabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "airportlabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "educationlabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "on"
      }
    }, {
      "featureType": "educationlabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "companylabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "lifeservicelabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "on"
      }
    }, {
      "featureType": "district",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#00f0ffff"
      }
    }, {
      "featureType": "district",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#ffffff0"
      }
    }, {
      "featureType": "town",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#00f0ffff"
      }
    }, {
      "featureType": "town",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#ffffff0"
      }
    }, {
      "featureType": "village",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#ffffff0"
      }
    }, {
      "featureType": "village",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#00f0ffff"
      }
    }, {
      "featureType": "entertainmentlabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "on"
      }
    }, {
      "featureType": "entertainmentlabel",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#95bee5ff"
      }
    }, {
      "featureType": "entertainmentlabel",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#ffffff00"
      }
    }, {
      "featureType": "governmentlabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "on"
      }
    }, {
      "featureType": "medicallabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "medicallabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "lifeservicelabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "financelabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "financelabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "transportationlabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "on"
      }
    }, {
      "featureType": "carservicelabel",
      "elementType": "labels",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "carservicelabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "poilabel",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#95bee5ff"
      }
    }, {
      "featureType": "poilabel",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#ffffff0"
      }
    }, {
      "featureType": "educationlabel",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#ffffff0"
      }
    }, {
      "featureType": "educationlabel",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#95bee5ff"
      }
    }, {
      "featureType": "entertainmentlabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "shoppinglabel",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "shoppinglabel",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#ffffff0"
      }
    }, {
      "featureType": "lifeservicelabel",
      "elementType": "labels.text.stroke",
      "stylers": {
        "color": "#ffffff0"
      }
    }, {
      "featureType": "lifeservicelabel",
      "elementType": "labels.text.fill",
      "stylers": {
        "color": "#95bee5ff"
      }
    }, {
      "featureType": "tertiaryway",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }, {
      "featureType": "local",
      "elementType": "labels.icon",
      "stylers": {
        "visibility": "off"
      }
    }],
};


const getters = {
  isAuthenticated:state=>state.isAuthenticated,
  user:state=> state.user
};

const mutations = {
  [types.SET_AUTHENTICATED](state,isAuthenticated) {
    if (isAuthenticated) state.isAuthenticated = isAuthenticated
    else state.isAuthenticated =false
  },
  [types.SET_USER](state,user){
    if (user) state.user = user;
    else state.user ={}
  }
};

const actions = {
  setAuthenticated:({commit},isAuthenticated)=>{
    commit(types.SET_AUTHENTICATED,isAuthenticated)
  },
  setUser:({commit},user)=>{
    commit(types.SET_USER,user)
  }
};
export const store = new  Vuex.Store({
  getters,
  mutations,
  actions,
  state,
});
export default store



// WEBPACK FOOTER //
// ./src/store/store.js